define('underscore',['require','underscore_official'],function (require) {

  var _ = require('underscore_official');

  var templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%-([\s\S]+?)%>/g,
    escape      : /<%=([\s\S]+?)%>/g
  };

  _.toggle = function(f1, f2) {
    var even = false;

    return function() {
      even ? f2() : f1();
      even = !even;
    };
  };

  _.cycleIndex = function(arr, currentIndex) {
    return currentIndex+1 === arr.length ? 0 : currentIndex+1;
  };

  // From:
  // Underscore-Awesomer.js 1.2.0
  // (c) 2011 Kevin Malakoff.
  // https://github.com/kmalakoff/underscore-awesomer/

  // Does the dot-delimited or array of keys path to a value exist.
  _.hasKeypath = _.keypathExists = function(object, keypath) {
    return !!_.keypathValueOwner(object, keypath);
  };

  // Finds the object that has or 'owns' the value if a dot-delimited or array of keys path to a value exists.
  _.keypathValueOwner = function(object, keypath) {
    var keypath_components = _.isString(keypath) ? keypath.split('.') : keypath;
    if (keypath_components.length===1) return ((object instanceof Object) && (keypath in object)) ? object : void 0; // optimization
    var key, current_object = object;
    for (var i = 0, l = keypath_components.length; i < l;) {
      key = keypath_components[i];
      if (!(key in current_object)) break;
      if (++i === l) return current_object;
      current_object = current_object[key];
      if (!current_object || !(current_object instanceof Object)) break;
    }
    return void 0;
  };

  // Gets (if value parameter void 0) or sets a value if a dot-delimited or array of keys path exists.
  _.keypath = function(object, keypath, value) {
    var keypath_components = _.isString(keypath) ? keypath.split('.') : keypath;
    var value_owner = _.keypathValueOwner(object, keypath_components);
    if (_.isUndefined(value)) {
      if (!value_owner) return void 0;
      return value_owner[keypath_components[keypath_components.length-1]];
    }
    else {
      if (!value_owner) return;
      value_owner[keypath_components[keypath_components.length-1]] = value;
      return value_owner[keypath_components[keypath_components.length-1]];
    }
  };

  _.findIndex = function(list, iterator) {
    for (var i = 0; i < list.length; i++) {
      if (iterator(list[i])) {
        return i;
      }
    }

    return -1;
  };

  _.isPromise = function(val) {
    return _.isObject(val) && _.isFunction(val.done) && _.isFunction(val.fail);
  };

  _.isDeferred = function(val) {
    return _.isObject(val) && _.isPromise(val) && _.isFunction(val.resolve) && _.isFunction(val.reject);
  };

  _.isModel = function(val) {
    return val instanceof Backbone.Model;
  };

  _.isCollection = function(val) {
    return val instanceof Backbone.Collection;
  };

  /**
   * Strict parsing of integers. Will return NaN for strings that start with a number.
   * @param value
   * @returns {*}
   */
  _.filterInt = function (value) {
    if(/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
      return Number(value);
    return NaN;
  }

  _.isDefined = function(obj) {
    return !_.isUndefined(obj);
  };

  _.deepClone = function(obj) {
    if (_.isObject(obj)) {
      return JSON.parse(JSON.stringify(obj));
    } else {
      return obj;
    }
  };

  _.extend(_, {
    templateSettings: templateSettings
  });

  return _;
});

